import { render, staticRenderFns } from "./newdrawlottery.vue?vue&type=template&id=208c8500&scoped=true"
import script from "./newdrawlottery.vue?vue&type=script&lang=js"
export * from "./newdrawlottery.vue?vue&type=script&lang=js"
import style0 from "./newdrawlottery.vue?vue&type=style&index=0&id=208c8500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c8500",
  null
  
)

export default component.exports